export type BillingsOrderCargoTaxiCreateParamsBillingNode = {
  uuid: string;
  nodeUuid: string;
  checkoutEventUuid?: string;
  lat: number;
  lon: number;
  description: string;
  editableCoordinates: boolean;
  checkoutDate?: Date;
  plannedDate?: Date;
  orderUuid?: string;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
};

export enum BillingsOrderCargoTaxiCreateParamsContributionType {
  DISCOUNT_OPTIMIZATION = "DISCOUNT_OPTIMIZATION",
  DISCOUNT_BEING_LATE = "DISCOUNT_BEING_LATE",
  DISCOUNT_INCOMPATIBLE_CAR = "DISCOUNT_INCOMPATIBLE_CAR",
  DISCOUNT_OTHER = "DISCOUNT_OTHER",
  CONTRACT_CORRECTION_PERCENTAGE = "CONTRACT_CORRECTION_PERCENTAGE",
}

export type BillingsOrderCargoTaxiCreateParamsContributionContractCorrectionPercentage =
  {
    type: BillingsOrderCargoTaxiCreateParamsContributionType.CONTRACT_CORRECTION_PERCENTAGE;
    comment?: string;
    percentage: number;
    amount: number;
  };

export type BillingsOrderCargoTaxiCreateParamsContributionDiscountOptimization =
  {
    type: BillingsOrderCargoTaxiCreateParamsContributionType.DISCOUNT_OPTIMIZATION;
    comment?: string;
    amount: number;
  };

export type BillingsOrderCargoTaxiCreateParamsContributionDiscountBeingLate = {
  type: BillingsOrderCargoTaxiCreateParamsContributionType.DISCOUNT_BEING_LATE;
  comment?: string;
  amount: number;
};

export type BillingsOrderCargoTaxiCreateParamsContributionDiscountIncompatibleCar =
  {
    type: BillingsOrderCargoTaxiCreateParamsContributionType.DISCOUNT_INCOMPATIBLE_CAR;
    comment?: string;
    amount: number;
  };

export type BillingsOrderCargoTaxiCreateParamsContributionDiscountOther = {
  type: BillingsOrderCargoTaxiCreateParamsContributionType.DISCOUNT_OTHER;
  comment?: string;
  amount: number;
};

export type BillingsOrderCargoTaxiCreateParamsContribution =
  | BillingsOrderCargoTaxiCreateParamsContributionContractCorrectionPercentage
  | BillingsOrderCargoTaxiCreateParamsContributionDiscountOptimization
  | BillingsOrderCargoTaxiCreateParamsContributionDiscountBeingLate
  | BillingsOrderCargoTaxiCreateParamsContributionDiscountIncompatibleCar
  | BillingsOrderCargoTaxiCreateParamsContributionDiscountOther;

type BillingsOrderCargoTaxiCreateParams = {
  orderUuid: string;
  billingNodes: BillingsOrderCargoTaxiCreateParamsBillingNode[];
  billingContributions: BillingsOrderCargoTaxiCreateParamsContribution[];
};

export default BillingsOrderCargoTaxiCreateParams;
